export const MenuIdPlans = 'PLANS' as const;
